(function () {
    String.prototype.replaceAll = function (str1, str2, ignore) {
        return this.replace(new RegExp(str1.replace(/([\/\,\!\\\^\$\{\}\[\]\(\)\.\*\+\?\|\<\>\-\&])/g, "\\$&"), (ignore
            ? "gi"
            : "g")), (typeof (str2) == "string") ? str2.replace(/\$/g, "$$$$") : str2);
    };

    String.prototype.endsWith = function (suffix) {
        if (!suffix || !_.isString(suffix)) {
            return false;
        }
        return this.indexOf(suffix, this.length - suffix.length) !== -1;
    };
})();